import "core-js/modules/es6.array.map.js";
var upperCaseArray = function upperCaseArray(array) {
  return array.map(function (element) {
    return element.toUpperCase();
  });
};
export default upperCaseArray;